module.exports = __webpack_public_path__ + "static/media/DBHeaventNow-BoldIt.fba0f837.woff";